module.exports = __webpack_public_path__ + "img/DSC00675-2.22b35d1d.jpg";